const questions = [
  {
    type: "QUESTION",
    payload: {
      question:
        "What is the maximum duration for a single Whereby cloud recording?",
      alternatives: {
        A: "24 hours",
        B: "12 hours",
      },
      correctAlternative: "A",
    },
  },
  {
    type: "QUESTION",
    payload: {
      question:
        "What is the maximum video resolution for the Whereby Embedded API?",
      alternatives: {
        A: "1080p",
        B: "720p",
      },
      correctAlternative: "B",
    },
  },
  {
    type: "QUESTION",
    payload: {
      question:
        "What is the minimum required plan for using the Whereby Embedded API's cloud recording feature?",
      alternatives: {
        A: "Build plan",
        B: "Free plan",
      },
      correctAlternative: "A",
    },
  },
  {
    type: "QUESTION",
    payload: {
      question:
        "What technology do Whereby background effects use under the hood?",
      alternatives: {
        A: "Wasm",
        B: "Flash",
      },
      correctAlternative: "A",
    },
  },
  // {
  //   type: "QUESTION",
  //   payload: {
  //     question:
  //       "Can the Whereby Embedded API be used to integrate video meetings into a mobile application?",
  //     alternatives: {
  //       A: "True",
  //       B: "False",
  //     },
  //     correctAlternative: "A",
  //   },
  // },

  // {
  //   type: "QUESTION",
  //   payload: {
  //     question:
  //       "What is the status code we respond with when throttling an API request?",
  //     alternatives: {
  //       A: "429",
  //       B: "404",
  //     },
  //     correctAlternative: "A",
  //   },
  // },
  // {
  //   type: "QUESTION",
  //   payload: {
  //     question:
  //       "What is the minimum required plan for removing the branding bar from the meeting UI?",
  //     alternatives: {
  //       A: "Build plan",
  //       B: "Grow plan",
  //     },
  //     correctAlternative: "A",
  //   },
  // },
  // {
  //   type: "QUESTION",
  //   payload: {
  //     question:
  //       "Can the Whereby Embedded API be used to create and manage user accounts within a Whereby organization?",
  //     alternatives: {
  //       A: "False",
  //       B: "True",
  //     },
  //     correctAlternative: "A",
  //   },
  // },
  // {
  //   type: "QUESTION",
  //   payload: {
  //     question:
  //       "What is the name of the public Whereby Embedded API endpoint for creating new meeting rooms?",
  //     alternatives: {
  //       A: "/rooms",
  //       B: "/meetings",
  //     },
  //     correctAlternative: "B",
  //   },
  // },
  // {
  //   type: "QUESTION",
  //   payload: {
  //     question:
  //       "Is it possible to customize the branding of a video meeting room using the Whereby Embedded API?",
  //     alternatives: {
  //       A: "True",
  //       B: "False",
  //     },
  //     correctAlternative: "A",
  //   },
  // },
];

export default questions;
